export enum Environment {
  PRODUCTION = 'PRODUCTION',
  SANDBOX = 'SANDBOX',
  DEVELOPMENT = 'DEVELOPMENT',
  TESTING = 'TESTING',
}
